import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardMedia, Typography, Button, Grid, CircularProgress } from '@mui/material';
import SendIcon from '@mui/icons-material/ArrowForward';
import Parser from 'html-react-parser';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useDevice } from 'components/DeviceContext.js';

const NewsComponent = () => {
	const { isMobile, isLaptop } = useDevice();
	const [noticias, setNoticias] = useState([]);
	const [loading, setLoading] = useState(true); // Defina o estado inicial como true para mostrar o indicador de carregamento

	const removeImages = (htmlContent) => {
		const modifiedContent = htmlContent.replace(/<img.*?>/g, '');
		return modifiedContent;
	};

	const shortenText = (text, maxLength) => {
		if (text.length > maxLength) {
			return text.slice(0, maxLength - 3) + '...';
		} else {
			return text;
		}
	};

	useEffect(() => {
		axios
			.get('https://cnm.org.br/api/noticias?limit=3&categoria=observatorio-municipal-de-drogas&sort=created_at&order=desc')
			.then((response) => {
				const noticiasData = response.data.noticias.data.map((noticia) => {
					if (!noticia.imagem.startsWith('http') && !noticia.imagem.startsWith('www')) {
						noticia.imagem = `https://cnm.org.br${noticia.imagem}`;
					}

					noticia.conteudo = noticia.conteudo.replace(/[^\x20-\x7E]/g, '');
					return noticia;
				});
				setNoticias(noticiasData);
				setLoading(false); 
			})
			.catch((error) => {
				console.error('Erro ao obter notícias:', error);
			});
	}, []);

	if (loading) {
		return (
			<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
				<CircularProgress /> {/* Mostra o indicador de carregamento enquanto os dados estão sendo carregados */}
			</div>
		);
	}

	return (
		<Grid container justifyContent="center" style={{ backgroundColor: 'var(--azul-escuro)', color: 'var(--branco)' }}>
			<Grid item xs={12} align="center">
				<h1 style={{ textTransform: 'uppercase', fontSize: isMobile ? '17px' : '24px' }}>
					Últimas notícias sobre Política de drogas
				</h1>
			</Grid>
			{noticias.map((article, index) => (
				<Grid item key={index} xs={12} sm={6} md={4} lg={3}>
					<Card style={{ maxWidth: 300, maxHeight: 500, margin: '20px', backgroundColor: 'var(--azul-card)', padding: isLaptop ? '1em' : '2em', borderRadius: '2em', color: 'var(--branco)', height: '80%', display: 'flex', flexDirection: 'column' }}>
						<CardMedia
							style={{ height: isLaptop ? 100 : 200, borderRadius: 20 }}
							image={article.imagem}
							title={article.title}
						/>
						<CardContent>
							<span style={{ display: 'flex', justifyContent: 'end', paddingBottom: '0.2em' }}>{article.datetime}</span>
							<Typography gutterBottom variant="h9" component="h2" style={{ display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '1em' }}>
								{article.titulo}
							</Typography>
							<Typography variant="body2" color="textSecondary" component="div" style={{ maxHeight: 150, overflow: 'hidden', textOverflow: 'ellipsis', color: 'var(--branco)', fontSize: '0.9em', display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 5 }}>
								{Parser(removeImages(shortenText(article.conteudo, 0)))}
							</Typography>
							<Grid container justifyContent="flex-end" style={{ marginBottom: '-40px', marginTop: '5px' }}>
								<Button
									component={Link}
									to={`/noticia/${article.id}`}
									size="large"
									style={{ color: 'var(--branco)', fontWeight: '600' }}
									endIcon={<SendIcon />}  // Aqui usamos endIcon para adicionar o ícone ao final
								>
									Ler mais
								</Button>

							</Grid>
						</CardContent>
					</Card>
				</Grid>
			))}
			<Grid item xs={12} align="center">
				<Button
					component={Link}
					to="/noticias"
					variant="contained"
					style={{ marginTop: '20px', backgroundColor: 'var(--azul-card)', color: 'var(--branco)', borderRadius: '20px', padding: '10px 20px' }}
				>
					Ver mais notícias
				</Button>
			</Grid>
		</Grid>
	);
};

export default NewsComponent;
